(function($) {
    var MSG_DIGIT = "Password must include at least one number.";
    var MSG_LETTER = "Password must include at least one letter.";
    var MSG_LENGTH = "Password must be at least eight characters long.";
    var MSG_UPPER  = "Password must include at least one capital letter.";
    var MSG_REPETITION = "Password contains more than 3 consecutive identical characters.";

    $.widget("ca.caPassword", {
        _create: function() {
            var self = this;

            this.element.on('blur', function() {
                var validationErrors = self.validate(this.value);                
                self.element.trigger('caPassword:validate', [
                    validationErrors
                ]);
            });
        },

        validate: function(value) {
            value = $.trim(value);            
            var length = value.length;        
            
            if (length < 8) {
                return MSG_LENGTH;
            }

            if (value.match(/[a-zA-Z]/) === null) {
                return MSG_LETTER;
            }

            if (value.match(/[\d]/) === null) {
                return MSG_DIGIT;
            }

            if (value.match(/[A-Z]/) === null) {
                return MSG_UPPER;
            }

            var lastChar = null;
            var charCount = 1;            
            for (var i = 0; i < length; i++) {
                if (value[i] == lastChar) {
                    charCount++;
                } else {
                    lastChar = value[i];
                    charCount = 1;
                }
                
                if (charCount > 2) {
                    return MSG_REPETITION;
                }
            }
                        
            return null;
        }
    });
})(jQuery);
